export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/901eadc49720f2fc2daf7d83f8fb4264.jpg"
          alt="Hero Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 text-center w-full">
        <div className="mb-6 inline-flex items-center space-x-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full border border-white/20">
          <i className="ri-shield-star-line text-emerald-400 text-lg"></i>
          <span className="text-white text-sm font-medium">Secure VPN Solution</span>
        </div>

        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          Your Privacy,
          <br />
          <span className="text-emerald-400">Our Priority</span>
        </h1>

        <p className="text-xl text-gray-200 mb-10 max-w-3xl mx-auto leading-relaxed">
          Experience ultimate online security with our advanced VPN technology. Browse anonymously, protect your data, and access content freely from anywhere in the world.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={scrollToContact}
            className="px-8 py-4 bg-emerald-600 text-white text-base font-semibold rounded-lg hover:bg-emerald-700 transition-all hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
          >
            Get Started Now
          </button>
          <button
            onClick={() => {
              const element = document.getElementById('features');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white text-base font-semibold rounded-lg hover:bg-white/20 transition-all border border-white/30 whitespace-nowrap cursor-pointer"
          >
            Learn More
          </button>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
            <i className="ri-lock-line text-emerald-400 text-4xl mb-3"></i>
            <h3 className="text-white text-lg font-semibold mb-2">Bank-Level Encryption</h3>
            <p className="text-gray-300 text-sm">Military-grade security protocols</p>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
            <i className="ri-speed-line text-emerald-400 text-4xl mb-3"></i>
            <h3 className="text-white text-lg font-semibold mb-2">Lightning Fast</h3>
            <p className="text-gray-300 text-sm">Optimized servers worldwide</p>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
            <i className="ri-eye-off-line text-emerald-400 text-4xl mb-3"></i>
            <h3 className="text-white text-lg font-semibold mb-2">Zero Logs Policy</h3>
            <p className="text-gray-300 text-sm">Complete privacy guaranteed</p>
          </div>
        </div>
      </div>
    </section>
  );
}
